import Ajax from "./request/index.js";

import { CURRENT_HOST_NAME } from "../utils/index"

let base = `//api-test.${CURRENT_HOST_NAME}`;

let baseOauth = `//oauth-uat.${CURRENT_HOST_NAME}`;

if (process.env.NODE_ENV === 'production') {
  base = process.env.VUE_APP_API_HOST.replace('shopshops.top', CURRENT_HOST_NAME) || `//api.${CURRENT_HOST_NAME}`;
  baseOauth = process.env.VUE_APP_OAUTH_API_HOST.replace('shopshops.top', CURRENT_HOST_NAME) || `//oauth.${CURRENT_HOST_NAME}`;
}

// url, method, name, throttle
const list = [
  [`${base}/app/live/get-live-room`, "get", "get_live_room", false],
  
  // 图片验证码
  [`${base}/app/user/generate-image-code`, 'get', 'get_img_code', false],
  
  [`${base}/app/live-interaction/list-msg`, "post", "list_msg", false],
  [`${base}/app/recommend/page-nrt-live`, "post", "get_home_list", false],
  [`${base}/app/live-interaction/get-rongyun-token`, "post", "get_rongyun_token", false],
  [`${base}/app/live/v2/list-live-merchandise`, "get", "list_live_merchandise", false],
  [`${base}/app/user/send-vcode`, "post", "send_v_code", false],
  [`${base}/app/user/mobile-login`, "post", "mobile_login", false],
  [`${base}/app/user/get-user-info-v2`, "get", "get_user_info", false],
  [`${base}/app/user/alipay-simple-login`, "post", "ZFB_login", false],
  [`${base}/app/merchandise/v2/sku/list-merchandise-sku`, "post", "list_merchandise_sku", false],
  [`${base}/app/trade/v2/orders/settlement-check`, "post", "settlement_check", false],
  [`${base}/app/user/get-default-user-addr`, "get", "get_default_user_addr", false],
  [`${base}/app/we-chart/trade/v2/orders/save-order`, "post", "save_order_wechat", false],
  [`${base}/app/trade/v2/orders/save-order`, "post", "save_order", false],
  [`${base}/app/operation/operation/choose-ticket`, "post", "choose_ticket", false],
  [`${base}/app/operation/v2/operation/choose-ticket`, "post", "set_ticket", false],
  [`${base}/app/operation/v2/operation/list-ticket-selection`, "post", "get_ticket_list", false],
  [`${base}/app/operation/v2/operation/choose-couponcode`, "post", "choose_couponcode", false],
  [`${base}/app/live-interaction/join-chat-room`, "post", "join_chat_room", false],
  [`${base}/app/user/list-user-addr-by-uid`, "get", "get_addr_list", false],
  [`${base}/app/user/get-user-addr-by-id`, "get", "get_addr_info", false],
  [`${base}/app/user/del-user-addr`, "get", "del_addr", false],
  [`${base}/app/user/update-user-addr-with-card`, "post", "update_addr", false],
  [`${base}/app/user/save-user-addr-with-card`, "post", "save_addr", false],
  [`${base}/app/trade/cart/save-cart`, "post", "save_cart", false],
  [`${base}/app/trade/cart/sku-num`, "get", "sku_num", false],
  [`${base}/app/trade/v2/cart/list-cart`, "get", "list_cart", false],
  [`${base}/app/user/v2/list-address-area`, "post", "get_addr_area", false],
  [`${base}/app/user/send-ecode`, "post", "send_e_code", false],
  [`${base}/app/user/email-register`, "post", "email_register", false],
  [`${base}/app/user/email-login`, "post", "email_login", false],
  [`${base}/app/user/reset-email-password`, "post", "email_reset", false],
  [`${base}/app/user/check-ecode`, "post", "email_checkcode", false],
  [`${baseOauth}/user/third-app-login`, "post", "facebook_login", false],
  [`${base}/app/host/live-add-host-like`, "post", "live_add_host_like", false],
  [`${base}/app/host/add-host-like`, "get", "add_host_like", false],
  [`${base}/app/live-interaction/check-send-msg-auth`, "get", "check_send_msg_auth", false],
  [`${base}/app/trade/cart/delete-cart-sku`, "post", "delete_cart_sku", false],
  [`${base}/app/agreement/list-content-by-key`, "post", "list_content_by_key", false],
  [`${base}/app/operation/operation/list-search-topic-banner`, 'post','operating_position', false],
  [`${base}/app/share/create-short-url`, 'post','create_short_url', false],
  [`${base}/app/user/user-bind-mobile-plus`, "post", "bind_mobile", false],
  [`${base}/app/user/third-party-login`, "post", "third_party_login", false],
   //goods
   [`${base}/app/merchandise/v2/merchandise/get-merchandise-detail`, 'post', 'get_goods_detail', false],
   [`${base}/app/trade/cart/sku-num`, 'get', 'get_cart_num', false],
   [`${base}/app/merchandise/v2/sku/list-merchandise-sku`, 'post', 'get_sku', false],
   [`${base}/app/user/add-merchandise-like`, 'get', 'collect_goods', false],
   [`${base}/app/share/create-short-url`, 'post','create_short_url', false],
   [`${base}/app/operation/pop/get-pop-windows`,'post','get_coupon_pop',false],
   [`${base}/app/trade/cart/save-cart`,'post','save_cart',false],
   [`${base}/app/trade/orders/list-orders-with-status`,'post','list_orders',false],
   [`${base}/app/trade/orders/cancel-order`,'post','cancel_order',false],
   [`${base}/app/trade/orders/update-order-status-by-id`,'post','delete_order',false],
 
   [`${base}/app/trade/orders/get-orders-detail-by-id`,'get','get_order_detail',false],
   [`${base}/app/trade/orders/cancel-order`,'post','cacel_order',false],
   [`${base}/app/trade/orders/confirm-receipt`,'post','confirm_receipt',false],
  [`${baseOauth}/user/FACEBOOK1/get-third-login-state`, "get", "facebook_login_state", false],

  [`${base}/app/operation/exchange-exchange_code`,'post','bind_invite_code',false],
  [`${base}/app/we-chart/trade/orders/payment`,'post','repayment',false],
  // 神策
  [`${base}/app/sensors/sensors-data`,'post','sensors',false],
  // 物流
  [`${base}/app/trade/order-merchandise/inquiry-logistics-new`,'get','get_logistics',false],
  
  //云信
  [`${base}/app/yunxin/get-yunxin-token`,'get','get_yunxin_token',false],
  [`${base}/app/user/add-merchandise-like`,'get','merchandise_like',false],


  [`${base}/app/host/fetch-host-brief`,'post','get_host_brief',false],
  [`${base}/app/store/get-store`,'get','get_store',false],
  [`${base}/app/store/list-store-live`,'post','list_store_live',false],
  [`${base}/app/store/list-store-media`,'post','list_store_media',false],
  [`${base}/app/operation/v2/operation/list-store-merchandise`,'post','list_store_merchandise',false],
  [`${base}/app/store/v2/list-store-merchandise`,'post','get_store_goods',false],
  [`${base}/app/user/del-user-like`,'post','cancel_store_collect',false],
  [`${base}/app/user/add-store-like`,'get','add_store_collect',false],

  //主播详情
  [`${base}/app/host/get-host-user-info`,'get','get_host_userinfo',false],
   //主播直播 预告列表
  [`${base}/app/live/list-simple-live`,'get','get_host_livelist',false],
  //获取主播回放
  [`${base}/app/live/list-playback`,'post','get_host_playback',false],
  //播过的店铺
  [`${base}/app/store/list-host-store`,'post','get_host_played_store',false],
  //主播的店铺
  [`${base}/app/store/get-host-store`,'post','get_host_store',false],
  [`${base}/app/host/list-host-assistant`,'post','host_invite_hosts',false],
 // 关注主播
  [`${base}/app/host/add-host-like`,'get','like_host',false],
  // 取消关注
  [`${base}/app/user/del-user-like-by-id`,'get','cancle_like_host',false],
   //取消开播提醒
  [`${base}/app/live-interaction/unfollow-prelive-remind`,'get','cancle_prelive_remind',false],
   //主播页面直播回放预告
  [`${base}/app/live/get-host-videos`,'post','get_host_videos',false],
   //订阅开播提醒
  [`${base}/app/live-interaction/follow-prelive-remind`,'post','follow_prelive_remind',false],
  [`${base}/app/live-interaction/follow-prelive-remind`,'get','follow_prelive_remind_get',false],

 //取消收藏商品
  [`${base}/app/user/del-user-like`,'post','cancel_collect_goods',false],
  //获取店内推荐商品
  [`${base}/app/store/v2/list-store-merchandise`,'post','get_store_recommend_goods',false],
  [`${base}/app/console/list-config`,'post','get_list_config',false],

  // 美元化项目 开关状态
  [`${base}/app/console/v2/dollar-enabled`,'get','get_dollar_enabled_status',false],
  [`${base}/app/user/get-user-info-by-user-num`,'get','get_user_info_by_user_num',false],

  // 获取融云 APP key
  [`${base}/app/live-interaction/get-rong-cloud-config`, "get", "get_rongyun_appkey", false],
  [`${base}/app/live-interaction/check-send-msg-auth`, "get", "check_msg_auth", false],
  //获取表情
  [`${base}/app/live-interaction/v2/list-quick-screen-phrases`, "post", "get_quick_phrases", false],
  [`${base}/app/user/check-user-name`, "post", "check_user_name", false],
  [`${base}/app/user/get-random-user-name`, "post", "get_random_user_name", false],
  [`${base}/app/user/update-user-info`, "post", "update_user_info", false],

  
];


export default Ajax(list);
